import { useState } from 'react'
import { Quintenzirkel } from '../components/Quintenzirkel'
import { Klaviatur } from '../components/Klaviatur'
import { InfoPanel } from '../components/InfoPanel'
import { KlangButtons } from '../components/KlangButtons'
import { dominante, subdominante } from '../domain/tonarten'
import type { Tonart } from '../types'

export function ErkundenPage() {
  const [tonart, setTonart] = useState<Tonart | null>(null)
  return (
    <div className="page erkunden">
      <header className="page-kopf">
        <h1>Erkunden</h1>
        <p>Tippe eine Tonart an, höre ihren Klang, lerne ihre Verwandten.</p>
      </header>
      <div className="layout-zwei-spalten">
        <Quintenzirkel
          ausgewaehlt={tonart}
          highlightedDom={tonart ? dominante(tonart) : null}
          highlightedSub={tonart ? subdominante(tonart) : null}
          onWaehle={setTonart}
        />
        <div>
          <InfoPanel tonart={tonart} />
          <KlangButtons tonart={tonart} />
        </div>
      </div>
      <Klaviatur hervorhebung={tonart} />
    </div>
  )
}
